import React, { useEffect, useState } from "react";
import StandardCard from "../StandardCard"; // 导入标准卡片组件
import { Toast } from "antd-mobile"; // 导入 Toast 组件
import ChangeLog from "../ChangeLog"; // 导入变更日志组件
import { getPublishedFiles } from "../../services/services"; // 导入获取已发布文件的服务函数
import styles from "./index.module.css"; // 导入组件样式

export default function FilesGroup({ paramsObj, name }) {
  // 解构参数对象
  const { category, product_category, series_id } = paramsObj;
  // 状态定义：文件列表
  const [files, setFiles] = useState([]);

  useEffect(() => {
    let ignore = false;
    async function httpPublishedFiles() {
      // 如果参数不完整，则不发送请求
      if (!category || !product_category || !series_id) return;
      // 发送获取已发布文件的请求
      const res = await getPublishedFiles({
        category,
        product_category,
        series_id,
      });
      if (res.status === 200) {
        // 如果组件未被卸载，则更新文件列表
        if (!ignore) {
          setFiles(res.result);
        }
      } else {
        // 显示错误提示
        Toast.show({
          content: res.error,
          duration: 3000,
        });
      }
    }
    httpPublishedFiles();
    // 组件卸载时取消未完成的请求
    return () => {
      ignore = true;
    };
  }, [category, product_category, series_id]);

  // 如果文件列表为空，则直接返回
  if (files.length === 0) return null;

  return (
    <>
      <div style={{ padding: 24 }}>
        {/* 显示文件组标题 */}
        <div className={styles.header}>{name}</div>
        {/* 显示文件列表 */}
        <div className={styles.content}>
          {/* 如果是固件类别，则显示变更日志组件 */}
          {files.length > 0 && category === "firmware" && (
            <ChangeLog series_id={series_id} />
          )}
          {/* 遍历显示每个文件的标准卡片组件 */}
          {files.map((item, index) => (
            <StandardCard
              key={index}
              data={item}
              category={category}
            />
          ))}
        </div>
      </div>
    </>
  );
}
